import {WorkflowStatusFilter} from './WorkflowStatusFilter'
import TemplateView from "../../../TemplateView";
import {ALL_FILTER} from "./utils";
import {convertToFilter} from './utils'

export default class WorkflowStatusFilterMenu extends TemplateView {
    constructor({
        onChangeSelection = () => {}
    }) {
        super(null)

        this.state = {
            allSelected: true,
            selectionState: {
                statusIds: [],
                statusTypes: []
            },
            statuses: []
        };

        this.onChangeSelection = onChangeSelection

        this.onStatePropertyChanged("allSelected", () => {this._updateView()});
        this.onStatePropertyChanged("selectionState", () => {this._updateSelection()});
        this.onStatePropertyChanged("statuses", () => {this._updateSelection()});
    }


    templateHtml() {
        return '<div class="taskStatusFilterMenu">' +
               '   <div class="allSection">' +
               '     <label>' +
               '        <input type="radio" class="selectAll"/>' +
               '        <div class="title"><%-allSelected%></div>' +
               '     </label>' +
               '   </div>' +
               '   <div class="customSection">' +
               '     <label>' +
               '        <input type="radio" class="customSelect"/>' +
               '        <div class="title"><%-customSelected%></div>' +
               '     </label>' +
               '  </div>' +
               '  <div class="statusSelection"></div>' +
               '</div>'
    }

    messageKeys() {
        return {
            allSelected: "workflow_filter_menu.all_statuses_selected",
            customSelected: "workflow_filter_menu.custom"
        };
    }

    afterRender() {
        this.statusesSelector = new WorkflowStatusFilter({
            onChangeSelectedItems: this._handleChangeSelectedItems,
        }).init(this.find(".statusSelection"));

        this.$selectAllRadio = this.find('.selectAll').on('change', () => {
            this._handleSelectAllOption()
        })
        this.$customSelectRadio = this.find('.customSelect').on('change', () => {
            this._handleCustomSelectOption()
        })
        this._updateView();
    }

    update() {
        super.update()
        this.statusesSelector.update()
    }

    _updateView() {
        this.$selectAllRadio.prop('checked', this.state.allSelected)
        this.$customSelectRadio.prop('checked', !this.state.allSelected)
        this.find(".selectAll").toggleClass("checked", this.state.allSelected);
        this.find(".customSelect").toggleClass("checked", !this.state.allSelected);
        this.find(".statusSelection").toggle(!this.state.allSelected);
        this.find('.customSection').toggleClass('boxShadowCustomSection', !this.state.allSelected)

        if (!this.state.allSelected)
            this.statusesSelector.update()
    }

    _updateSelection() {
        this.statusesSelector.setState({
            selection: convertToFilter(this.state.selectionState),
            statuses: this.state.statuses,
        });
    }

    _handleChangeSelectedItems = (selection) => {
        this.setStateInternal({
            selectionState: selection
        })
        this.onChangeSelection(this._getSelection())
    }

    _handleSelectAllOption() {
        this.setState({
            allSelected: true
        })

        this.onChangeSelection(this._getSelection())
    }

    _handleCustomSelectOption() {
        this.setState({
            allSelected: false
        });

        this.onChangeSelection(this._getSelection())
    }

    _getSelection() {
        if (this.state.allSelected) {
            return ALL_FILTER;
        } else {
            return {
                statusIds: this.state.selectionState.statusIds,
                statusTypes: this.state.selectionState.statusTypes,
                allSelected: false
            }
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/WorkflowStatusFilterMenu.js